import { Checkbox, Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';

import { ISubscriptionPlanPrice } from '../../../../types/interfaces/subscription-plan-price';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (changeRequest: ISubscriptionPlanPrice) => void,
  onDelete: (changeRequest: ISubscriptionPlanPrice) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.STRIPE_PRICE_ID,
      cellReducer: (price: ISubscriptionPlanPrice) => {
        return (
          <div className={classes.stripePriceId}>{price.stripePriceId}</div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.VALUE,
      cellReducer: (price: ISubscriptionPlanPrice) => {
        return <div className={classes.period}>{price.value}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.CURRENT,
      cellReducer: (plan: ISubscriptionPlanPrice) => {
        return (
          <div className={classes.stripePlanPriceId}>
            <Checkbox disabled checked={plan.current}></Checkbox>
          </div>
        );
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (price: ISubscriptionPlanPrice) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(price);
                        }}></EditActionButton>
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(price);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
